import React, { Component } from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)

class ResumeTable extends Component {
  confirmDelete = hash => {
    if (window.confirm(`Delete resume ${hash}? This action cannot be undone from the UI.`)) {
      this.props.onDelete(hash)
    }
  }

  renderRow = item => {
    const lastActivity = item.lastView || item.lastDownload
    return (
      <tr key={item.hashName} className={!item.status ? 'admin-row-deleted' : ''}>
        <td>
          <a
            href={`${process.env.REACT_APP_API_SERVE_URL}/${item.hashName}`}
            target="_blank"
            rel="noreferrer"
            className="admin-hash-link"
          >
            {item.hashName}
          </a>
        </td>
        <td>{item.name || <span className="admin-empty">—</span>}</td>
        <td>{item.views}</td>
        <td>{item.downloads}</td>
        <td>{lastActivity ? dayjs(lastActivity).fromNow() : <span className="admin-empty">—</span>}</td>
        <td>{dayjs(item.createdAt).fromNow()}</td>
        <td>
          {item.status ? (
            <button
              className="admin-btn-delete"
              onClick={() => this.confirmDelete(item.hashName)}
              disabled={this.props.deleting === item.hashName}
            >
              {this.props.deleting === item.hashName ? '...' : 'Delete'}
            </button>
          ) : (
            <span className="admin-badge-deleted">Deleted</span>
          )}
        </td>
      </tr>
    )
  }

  render() {
    const { items, page, total, limit, onPageChange } = this.props
    const totalPages = Math.ceil(total / limit)

    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Hash</th>
              <th>Name</th>
              <th>Views</th>
              <th>Downloads</th>
              <th>Last Activity</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>{items.map(this.renderRow)}</tbody>
        </table>

        {totalPages > 1 && (
          <div className="admin-pagination">
            <button
              className="admin-btn-page"
              disabled={page <= 1}
              onClick={() => onPageChange(page - 1)}
            >
              ← Prev
            </button>
            <span className="admin-page-info">
              Page {page} of {totalPages}
            </span>
            <button
              className="admin-btn-page"
              disabled={page >= totalPages}
              onClick={() => onPageChange(page + 1)}
            >
              Next →
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default ResumeTable
